// @flow

import { cmsAxios } from '../axios-config';

const sendInboxMessage = (message, conversationId) => {
  return cmsAxios.post(`/support-chat/conversations/${conversationId || 0}/messages/send`, message);
};

export default sendInboxMessage;
